export default function () {
  return {
    collection: 'directus_files',
    action (item) {
      return new Promise((resolve) => {
        const no_image = require(`@/assets/${item.src}`)

        const img = new Image()
        img.src = no_image
        img.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const context = canvas.getContext('2d')
          context.drawImage(img, 0, 0)
          const data = canvas.toDataURL('image/png')

          const params = {
            data,
            filename_disk: item.filename_disk,
            filename_download: item.filename_download,
            metadata: item.metadata
          }

          resolve(params)
        }
      })
    },

    data: [
      {
        src: 'no_image.png',
        filename_disk: 'no_image.png',
        filename_download: 'no_image',
        metadata: { type: 'no_image' }
      },

      // {
      //   src: 'member_1.jpg',
      //   filename_disk: 'member_1.jpg',
      //   filename_download: 'member_1'
      // },

      // {
      //   src: 'member_2.jpg',
      //   filename_disk: 'member_2.jpg',
      //   filename_download: 'member_2'
      // },

      // {
      //   src: 'member_3.jpg',
      //   filename_disk: 'member_3.jpg',
      //   filename_download: 'member_3'
      // }
    ]
  }
}
